/**
 * Copyright 2025 Beijing Volcano Engine Technology Co., Ltd. All Rights Reserved.
 * SPDX-license-identifier: BSD-3-Clause
 */

import { ConfigFactory } from './config';

export * from './common';

export const AIGC_PROXY_HOST = 'https://api.xmyunan.com/api/asr/proxyAIGCFetch';
export const DEMO_VERSION = '1.4.0';

export const Config = ConfigFactory;
export default new ConfigFactory();
